import { defineMessages } from 'react-intl'

export default defineMessages({
  placeholder: {
    id: 'containers.CustomerOrderUpsertPage.components.TextArea.placeholder',
    defaultMessage: 'Enter {name} here..',
  },
  charactersLeft: {
    id: 'containers.CustomerOrderUpsertPage.components.TextArea.charactersLeft',
    defaultMessage: '{charsLeft} characters left',
  },
})
